<template>
    <div class="inner">
        <div class="left">
            <div class="part">
                <icon-title title="中国在各领域与他国合著论文数量" iconName="wenben"></icon-title>
                <div class="chart" id="chart1">

                </div>
            </div>
            <div class="part">
                <icon-title title="中国在各领域与他国合著论文影响力" iconName="zuzhili"></icon-title>
                <div class="chart" id="chart2">
                </div>
            </div>
            <div class="part">
                <icon-title title="中国与他国合著论文数量" iconName="kjtzbxueke"></icon-title>
                <div class="chart" id="chart3">

                </div>
            </div>
        </div>
        <div class="center">
            <div class="part map">
                <div class="title">
                    <p>
                        中国与他国
                        <br>
                        合著论文情况
                    </p>
                </div>
                <div class="chart" id="map">

                </div>
            </div>
            <div class="part label">
                <div class="notice" ref="estimateList">
                    <div>
                        <p v-for="item in meetingData" :key="item.id">
                            <a :href="item.url" target="_blank">
                                {{ item.title }}
                            </a>
                        </p>
                    </div>
                </div>
                <div class="label-box">
                    <div class="label-box-item">
                        <p>
                            {{ mapTotalData[0] }}
                        </p>
                        <span>
                            合作机构数
                        </span>
                    </div>
                    <div class="label-box-item">
                        <p>
                            {{ mapTotalData[1] }}
                        </p>
                        <span>
                            合作论文数量
                        </span>
                    </div>
                    <div class="label-box-item">
                        <p>
                            {{ mapTotalData[2] }}
                        </p>
                        <span>
                            合作国作者数量
                        </span>
                    </div>
                    <div class="label-box-item">
                        <p>
                            {{ mapTotalData[3] }}
                        </p>
                        <span>
                            合作影响力
                        </span>
                    </div>
                </div>
            </div>
            <div class="part part-bootom">
                <div class="part-item">
                    <icon-title title="中国与他国合著论文影响力" iconName="jinxianshibutong"></icon-title>
                    <div class="chart" id="chart4">

                    </div>
                </div>
                <div class="part-item">
                    <icon-title title="各国论文中属于跨国合作的论文数量占比" iconName="fenjianguocheng"></icon-title>
                    <div class="chart" id="chart5">

                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="part part1">
                <p class="title">
                    各级科协学会办会场次
                </p>
                <div class="chart" id="chart6">

                </div>
            </div>
            <div class="part part2">
                <p class="title">
                    中国科协重要学术会议指南(2019)
                    <router-link to="/xsjl/zyxs">
                        <i class="icon"></i>
                    </router-link>
                </p>
                <div class="chart-box">
                    <div class="chart" id="chart7">
                    </div>
                    <p class="chart-title">
                        会议数量
                    </p>
                </div>
            </div>
            <div class="part part3">
                <div class="title">
                    与科技相关的国际交流情况

                    <div class="select-box">
                        <select name="" id="" v-model="projectStatusNum" @change="changeProjectStatus">
                            <option :value="item.id" v-for="item in projectStatusOpts" :key="item.id">
                                {{ item.label }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="chart" id="chart10">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconTitle from '@/components/icontitle';
    import {
        paperPublishCount,
        paperInfluence,
        paperCoCount,
        worldPublishCount,
        paperCoInfulence,
        paperCoScale,
        meetingScene,
        meetingGuide,
        projectStatus,
        getNewMeeting
    } from '@/assets/scripts/api/xsjl';

    const mapLineColor = '#00CCFF';
    const lineColor = '#2F46C1';
    const labelColor = '#B5C8FF';
    const mapColor = ['#cbfdff', '#8fadff', '#6278ff', '#4858e7', '#3f4cc3', '#232a6f', '#1a2165'];
    const lineChartColor1 = ['#EF9412', '#30CF70'];
    const lineChartColor2 = ['#00CCFF', '#FB058F'];
    const barColor = ['#344DD5', '#00CCFF'];
    const pieColor1 = ['#FB058F', '#06C0FB', '#0078FF', '#344DD5', '#EF9412', '#30CF70'];
    const pieColor = [
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        }
    ];


    export default {
        name: 'XueShuJiaoLiu',
        components: {
            IconTitle
        },
        data() {
            return {
                projectStatusOpts: [
                    {
                        id: 3,
                        label: '合作研究'
                    },
                    {
                        id: 5,
                        label: '展览会'
                    },
                    {
                        id: 4,
                        label: '培训'
                    },
                    {
                        id: 1,
                        label: '考察访问'
                    },
                    {
                        id: 2,
                        label: '会议'
                    }
                ],
                country: '日本,美国',
                countryData: ['日本', '美国'],
                projectStatusNum: 1,
                mapTotalData: [0, 0, 0, 0],
                meetingData: []
            };
        },
        mounted() {
            let that = this;
            this.$requireModul(['world'], function () {
                that.init();
            });
        },
        methods: {
            init() {
                // 中国在各领域与他国合著论文数量
                paperPublishCount().then(({data}) => {
                    this.initRadarChart1(data);
                })

                // 中国在各领域与他国合著论文影响力
                paperInfluence().then(({data}) => {
                    this.initRadarChart2(data);
                })


                // 中国与他国合著论文情况
                worldPublishCount().then(({data}) => {
                    this.initWorldMapChart(data);
                })

                // 中国与他国合著论文情况
                getNewMeeting().then(({data}) => {
                    this.meetingData = data;
                    this.$nextTick(() => {
                        this.$scrollTable(this.$refs.estimateList);
                    });
                })

                // 各级科协学会办会场次
                meetingScene().then(({data}) => {
                    this.initChart6(data);
                })

                // 中国科协重要学术会议指南
                meetingGuide().then(({data}) => {
                    this.initPieChart(data);
                })

                // 与科技相关的国际交流情况
                this.changeProjectStatus();

                this.initMapChart();
            },
            initMapChart() {
                // 中国与他国合著论文数量
                paperCoCount(this.country).then(({data}) => {
                    this.initChart3(data);
                })

                // 中国与他国合著论文影响力
                paperCoInfulence(this.country).then(({data}) => {
                    this.initChart4(data);
                })

                // 各国论文中属于跨国合作的论文数量占比
                paperCoScale(this.country).then(({data}) => {
                    this.initChart5(data);
                })
            },
            changeProjectStatus(){

                // 与科技相关的国际交流情况
                projectStatus(this.projectStatusNum).then(({data}) => {
                    this.initChart10(data);
                })
            },
            initRadarChart1(data){
                let chart1 = echarts.init(document.getElementById('chart1')),
                    option1 = this.creatRadarOption(data, 0);

                chart1.setOption(option1, true);
                chart1.resize();
                this.$winResize(chart1.resize);
            },
            initRadarChart2(data){
                let chart2 = echarts.init(document.getElementById('chart2')),
                    option2 = this.creatRadarOption(data, 1);

                chart2.setOption(option2, true);
                chart2.resize();
                this.$winResize(chart2.resize);
            },
            initChart3(data) {
                let chart3 = echarts.init(document.getElementById('chart3')),
                    option3 = this.creatLineOption(data);

                chart3.setOption(option3, true);
                chart3.resize();
                this.$winResize(chart3.resize);
            },
            initChart4(data) {
                let chart4 = echarts.init(document.getElementById('chart4')),
                    option4 = this.creatBarOption(data);

                chart4.setOption(option4, true);
                chart4.resize();
                this.$winResize(chart4.resize);
            },
            initChart5(data) {
                let chart5 = echarts.init(document.getElementById('chart5')),
                    option5 = this.creatLineOption(data);

                chart5.setOption(option5, true);
                chart5.resize();
                this.$winResize(chart5.resize);
            },
            initChart6(data) {
                let chart = echarts.init(document.getElementById('chart6')),
                    option = this.creatBarOption(data, 6);

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initPieChart(data) {
                let chart1 = echarts.init(document.getElementById('chart7')),
                    option = this.creatPieOption(data);

                chart1.setOption(option, true);
                chart1.resize();
                this.$winResize(chart1.resize);
            },
            initChart10(data) {
                let chart = echarts.init(document.getElementById('chart10')),
                    option = this.creatLineOption(data, 10);

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initWorldMapChart(data){
                let map = echarts.init(document.getElementById('map')),
                    option = this.getMapOption(data);

                map.setOption(option, true);
                map.resize();
                this.$winResize(map.resize);
                this.changeTipsData(data.all, map);
                this.changeMapChart(data.selected, map);
            },
            getMapOption(data) {
                let selectData = data.selected;
                let map = data.all;
                let valData = [];

                let mapData = map.map((item) => {
                    item.name == '美国' ? this.mapTotalData = item.value : '';

                    valData.push(item.value[1])

                    return {
                        value: item.value[1],
                        name: item.name
                    };
                });

                return {
                    tooltip: {
                        triggerOn: "mousemove",
                        formatter: function (params) {
                            let val = isNaN(params.value)? 0: params.value;

                            if (params.name !== '') {
                                var a = '<span>' + params.name + '</span>';
                                var b = '<span>' + val + '</span>';
                                return [a, b].join(' :  ');
                            }
                        },
                        backgroundColor: 'rgba(29, 38, 71)',
                    },
                    geo: {
                        show: true,
                        map: 'world',
                        zoom: 1.2,
                        label: {
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderWidth: 0,
                                areaColor: '#fff'
                            },
                            emphasis: {
                                areaColor: '#cbfdff'
                            }
                        },
                        nameMap: {
                            Afghanistan: '阿富汗',
                            Singapore: '新加坡',
                            Angola: '安哥拉',
                            Albania: '阿尔巴尼亚',
                            'United Arab Emirates': '阿联酋',
                            Argentina: '阿根廷',
                            Armenia: '亚美尼亚',
                            'French Southern and Antarctic Lands': '法属南半球和南极领地',
                            Australia: '澳大利亚',
                            Austria: '奥地利',
                            Azerbaijan: '阿塞拜疆',
                            Burundi: '布隆迪',
                            Belgium: '比利时',
                            Benin: '贝宁',
                            'Burkina Faso': '布基纳法索',
                            Bangladesh: '孟加拉国',
                            Bulgaria: '保加利亚',
                            'The Bahamas': '巴哈马',
                            'Bosnia and Herzegovina': '波斯尼亚和黑塞哥维那',
                            Belarus: '白俄罗斯',
                            Belize: '伯利兹',
                            Bermuda: '百慕大',
                            Bolivia: '玻利维亚',
                            Brazil: '巴西',
                            Brunei: '文莱',
                            Bhutan: '不丹',
                            Botswana: '博茨瓦纳',
                            'Central African Republic': '中非共和国',
                            Canada: '加拿大',
                            Switzerland: '瑞士',
                            Chile: '智利',
                            China: '中国',
                            'Ivory Coast': '象牙海岸',
                            Cameroon: '喀麦隆',
                            'Democratic Republic of the Congo': '刚果民主共和国',
                            'Republic of the Congo': '刚果共和国',
                            Colombia: '哥伦比亚',
                            'Costa Rica': '哥斯达黎加',
                            Cuba: '古巴',
                            'Northern Cyprus': '北塞浦路斯',
                            Cyprus: '塞浦路斯',
                            'Czech Republic': '捷克共和国',
                            Germany: '德国',
                            Djibouti: '吉布提',
                            Denmark: '丹麦',
                            'Dominican Republic': '多明尼加共和国',
                            Algeria: '阿尔及利亚',
                            Ecuador: '厄瓜多尔',
                            Egypt: '埃及',
                            Eritrea: '厄立特里亚',
                            Spain: '西班牙',
                            Estonia: '爱沙尼亚',
                            Ethiopia: '埃塞俄比亚',
                            Finland: '芬兰',
                            Fiji: '斐',
                            'Falkland Islands': '福克兰群岛',
                            France: '法国',
                            Gabon: '加蓬',
                            'United Kingdom': '英国',
                            Georgia: '格鲁吉亚',
                            Ghana: '加纳',
                            Guinea: '几内亚',
                            Gambia: '冈比亚',
                            'Guinea Bissau': '几内亚比绍',
                            Greece: '希腊',
                            Greenland: '格陵兰',
                            Guatemala: '危地马拉',
                            'French Guiana': '法属圭亚那',
                            Guyana: '圭亚那',
                            Honduras: '洪都拉斯',
                            Croatia: '克罗地亚',
                            Haiti: '海地',
                            Hungary: '匈牙利',
                            Indonesia: '印度尼西亚',
                            India: '印度',
                            Ireland: '爱尔兰',
                            Iran: '伊朗',
                            Iraq: '伊拉克',
                            Iceland: '冰岛',
                            Israel: '以色列',
                            Italy: '意大利',
                            Jamaica: '牙买加',
                            Jordan: '约旦',
                            Japan: '日本',
                            Kazakhstan: '哈萨克斯坦',
                            Kenya: '肯尼亚',
                            Kyrgyzstan: '吉尔吉斯斯坦',
                            Cambodia: '柬埔寨',
                            Kosovo: '科索沃',
                            Kuwait: '科威特',
                            Laos: '老挝',
                            Lebanon: '黎巴嫩',
                            Liberia: '利比里亚',
                            Libya: '利比亚',
                            'Sri Lanka': '斯里兰卡',
                            Lesotho: '莱索托',
                            Lithuania: '立陶宛',
                            Luxembourg: '卢森堡',
                            Latvia: '拉脱维亚',
                            Morocco: '摩洛哥',
                            Moldova: '摩尔多瓦',
                            Madagascar: '马达加斯加',
                            Mexico: '墨西哥',
                            Macedonia: '马其顿',
                            Mali: '马里',
                            Myanmar: '缅甸',
                            Montenegro: '黑山',
                            Mongolia: '蒙古',
                            Mozambique: '莫桑比克',
                            Mauritania: '毛里塔尼亚',
                            Malawi: '马拉维',
                            Malaysia: '马来西亚',
                            Namibia: '纳米比亚',
                            'New Caledonia': '新喀里多尼亚',
                            Niger: '尼日尔',
                            Nigeria: '尼日利亚',
                            Nicaragua: '尼加拉瓜',
                            Netherlands: '荷兰',
                            Norway: '挪威',
                            Nepal: '尼泊尔',
                            'New Zealand': '新西兰',
                            Oman: '阿曼',
                            Pakistan: '巴基斯坦',
                            Panama: '巴拿马',
                            Peru: '秘鲁',
                            Philippines: '菲律宾',
                            'Papua New Guinea': '巴布亚新几内亚',
                            Poland: '波兰',
                            'Puerto Rico': '波多黎各',
                            'North Korea': '北朝鲜',
                            Portugal: '葡萄牙',
                            Paraguay: '巴拉圭',
                            Qatar: '卡塔尔',
                            Romania: '罗马尼亚',
                            Russia: '俄罗斯',
                            Rwanda: '卢旺达',
                            'Western Sahara': '西撒哈拉',
                            'Saudi Arabia': '沙特阿拉伯',
                            Sudan: '苏丹',
                            'South Sudan': '南苏丹',
                            Senegal: '塞内加尔',
                            'Solomon Islands': '所罗门群岛',
                            'Sierra Leone': '塞拉利昂',
                            'El Salvador': '萨尔瓦多',
                            Somaliland: '索马里兰',
                            Somalia: '索马里',
                            'Republic of Serbia': '塞尔维亚',
                            Suriname: '苏里南',
                            Slovakia: '斯洛伐克',
                            Slovenia: '斯洛文尼亚',
                            Sweden: '瑞典',
                            Swaziland: '斯威士兰',
                            Syria: '叙利亚',
                            Chad: '乍得',
                            Togo: '多哥',
                            Thailand: '泰国',
                            Tajikistan: '塔吉克斯坦',
                            Turkmenistan: '土库曼斯坦',
                            'East Timor': '东帝汶',
                            'Trinidad and Tobago': '特里尼达和多巴哥',
                            Tunisia: '突尼斯',
                            Turkey: '土耳其',
                            Uganda: '乌干达',
                            Ukraine: '乌克兰',
                            Uruguay: '乌拉圭',
                            'United States': '美国',
                            Uzbekistan: '乌兹别克斯坦',
                            Venezuela: '委内瑞拉',
                            Vietnam: '越南',
                            Vanuatu: '瓦努阿图',
                            'West Bank': '西岸',
                            Yemen: '也门',
                            'South Africa': '南非',
                            Zambia: '赞比亚',
                            Korea: '韩国',
                            Tanzania: '坦桑尼亚',
                            Zimbabwe: '津巴布韦',
                            Congo: '刚果',
                            'Central African Rep.': '中非',
                            Serbia: '塞尔维亚',
                            'Bosnia and Herz.': '波黑',
                            'Czech Rep.': '捷克',
                            'W. Sahara': '西撒哈拉',
                            'Lao PDR': '老挝',
                            'Dem.Rep.Korea': '朝鲜',
                            'Falkland Is.': '福克兰群岛',
                            'Timor-Leste': '东帝汶',
                            'Solomon Is.': '所罗门群岛',
                            Palestine: '巴勒斯坦',
                            'N. Cyprus': '北塞浦路斯',
                            Aland: '奥兰群岛',
                            'Fr. S. Antarctic Lands': '法属南半球和南极陆地',
                            Mauritius: '毛里求斯',
                            Comoros: '科摩罗',
                            'Eq. Guinea': '赤道几内亚',
                            'Guinea-Bissau': '几内亚比绍',
                            'Dominican Rep.': '多米尼加',
                            'Saint Lucia': '圣卢西亚',
                            Dominica: '多米尼克',
                            'Antigua and Barb.': '安提瓜和巴布达',
                            'U.S. Virgin Is.': '美国原始岛屿',
                            Montserrat: '蒙塞拉特',
                            Grenada: '格林纳达',
                            Barbados: '巴巴多斯',
                            Samoa: '萨摩亚',
                            Bahamas: '巴哈马',
                            'Cayman Is.': '开曼群岛',
                            'Faeroe Is.': '法罗群岛',
                            'IsIe of Man': '马恩岛',
                            Malta: '马耳他共和国',
                            Jersey: '泽西',
                            'Cape Verde': '佛得角共和国',
                            'Turks and Caicos Is.': '特克斯和凯科斯群岛',
                            'St. Vin. and Gren.': '圣文森特和格林纳丁斯'
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: Math.max.apply(null, valData),
                        show: false,
                        inRange: {
                            color: mapColor
                        }
                    },
                    series: [
                        {
                            type: 'map',
                            geoIndex: 0,
                            data: mapData
                        },
                        {
                            name: '散点',
                            type: 'scatter',
                            coordinateSystem: 'geo',
                            data: this.convertData(selectData),
                            symbolSize: 10,
                            label: {
                                color: '#fff',
                                formatter: '{b}',
                                position: 'left',
                                show: true,
                                lineHeight: 20,
                                borderColor: mapLineColor,
                                borderWidth: 1,
                                padding: [0, 11],
                                fontSize: 14,
                                borderRadius: 2,
                                backgroundColor: 'rgba(8,11,38,0.8)'
                            },
                            itemStyle: {
                                borderColor: mapLineColor,
                                shadowBlur: 10,
                                shadowColor: mapLineColor
                            },
                            tooltip: {
                                show: false
                            },
                            hoverAnimation: false,
                            zlevel: 2
                        }
                    ]
                };
            },
            convertData(selectData) {
                let res = [];

                selectData.forEach((item) => {
                    let value = [];

                    value.push(item.lon);
                    value.push(item.lat);

                    res.push({
                        name: item.name,
                        value: value
                    });
                });

                return res;
            },
            changeTipsData(map, chart) {
                let that = this;

                chart.on('mouseover', (params) => {
                    let name = params.name;

                    map.forEach((item) => {

                        if (item.name == name) {
                            setData(item);
                        }
                    });
                });

                chart.on('mouseout', () => {
                    setData(map[0]);
                });

                let setData = (data) => {
                    data && data.value ? that.mapTotalData = data.value : '';
                };

            },
            changeMapChart(selectData, chart) {

                // 11个城市点击后切换图表
                chart.on('click', (params) => {
                    if (!params.data) {
                        return;
                    }

                    const name = params.data.name;

                    selectData.forEach((item) => {

                        if (name !== item.name) {
                            return;
                        }

                        const hasIdx = this.countryData.indexOf(name);

                        if (hasIdx >= 0) {
                            this.countryData.splice(hasIdx, 1);

                        } else {

                            if (this.countryData.length >= 2) {
                                this.countryData.splice(0, 1);
                            }

                            this.countryData.push(name);
                        }

                        this.country = this.countryData.join(',');
                        this.initMapChart();
                    });
                });
            },
            creatRadarOption(data, type) {
                let indicatorData = this.getchartData(data);
                const option = {
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    radar: {
                        splitNumber: 2,
                        radius: '65%',
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        splitArea: false,
                        splitLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        nameGap: 10,
                        name: {
                            formatter: function (value) {
                                if (value.length > 4) {
                                    value = value.slice(0, 3) + '\n' + value.slice(3);
                                }
                                return value;
                            },
                            textStyle: {
                                color: labelColor,
                                fontSize: 14,
                            }
                        },
                        indicator: indicatorData
                    },
                    series: [{
                        type: 'radar',
                        name: '',
                        data: [data.list],
                        symbolSize: 6,
                        lineStyle: {
                            color: pieColor[type].line
                        },
                        areaStyle: {
                            color: pieColor[type].area
                        },
                        itemStyle: {
                            color: pieColor[type].line,
                            borderWidth: 2
                        }

                    }]
                };

                return option;
            },
            getchartData(data) {
                let indicatorData = [];

                data.column.forEach((item) => {
                    let max = Math.max.apply(null, data.list),
                        obj = {
                            name: item,
                            max: max
                        };

                    indicatorData.push(obj);
                });

                return indicatorData;
            },
            creatLineOption(data, type){
                let option,
                    color = type ? lineChartColor2 : lineChartColor1,
                    seriesData = [],
                    lengendData = [];

                data.list.forEach((item, index) => {

                    seriesData.push({
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 6,
                        name: data.title[index],
                        itemStyle: {
                            normal: {
                                color: color[index],
                                lineStyle: {
                                    color: color[index],
                                }
                            }
                        },
                        data: item
                    });

                    lengendData.push({
                        name: data.title[index],
                        icon: 'circle',
                        textStyle: {
                            color: labelColor,
                            margin: 7
                        }
                    })
                });

                option = {
                    legend: {
                        align: 'left',
                        position: 'center',
                        itemWidth: 6,
                        itemHeight: 6,
                        itemGap: 20,
                        bottom: type ? '-2%' : '10%',
                        data: lengendData
                    },
                    grid: {
                        left: '0',
                        top: '11%',
                        bottom: type ? '9%' : '20%',
                        right: '0',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis',
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            show: true,
                            margin: 12,
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        axisTick: {
                            show: true,
                            alignWithLabel: true,
                            lineStyle: {
                                color: lineColor,
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        data: data.column
                    },
                    yAxis: {
                        scale: false,
                        nameTextStyle: {
                            color: labelColor
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            formatter: '{value}',
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    series: seriesData
                };

                return option;

            },
            creatBarOption(data, type) {
                let option,
                    color = type ? barColor : lineChartColor1,
                    barWidth = type ? 10 : 40,
                    seriesData = [],
                    lengendData = [];

                if (data.list && data.list.length) {

                    if (type == 6) {
                        data.list.forEach((item, index) => {
                            var title = index >= 2 ? data.title[index].substring(0, 3) : data.title[index].substring(0, 2);

                            seriesData.push({
                                type: 'bar',
                                barWidth: barWidth,
                                barGap: '10%',
                                name: title,
                                itemStyle: {
                                    normal: {
                                        show: true,
                                        color: color[index]
                                    }
                                },
                                data: item
                            });

                            lengendData.push({
                                name: title,
                                icon: 'rect',
                                textStyle: {
                                    color: labelColor,
                                    margin: 7
                                }
                            })
                        });
                    } else {

                        let DATA = data.list.map((item, index) => {
                            return {
                                value: item,
                                itemStyle: {
                                    color: color[index]
                                }
                            }
                        })

                        seriesData.push({
                            type: 'bar',
                            barWidth: barWidth,
                            barGap: '10%',
                            data: DATA
                        });
                    }
                }

                option = {
                    color: color,
                    tooltip: {
                        trigger: 'axis',
                    },
                    legend: {
                        align: 'left',
                        position: 'center',
                        itemWidth: 12,
                        itemHeight: 12,
                        itemGap: 20,
                        bottom: '0',
                        data: lengendData
                    },
                    grid: {
                        left: '0',
                        top: '11%',
                        bottom: type ? '15%' : '20%',
                        right: '0',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        axisTick: {
                            show: true,
                            alignWithLabel: true,
                            lineStyle: {
                                color: lineColor,
                            }
                        },
                        data: data.column
                    },
                    yAxis: {
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: type ? true : false,
                            lineStyle: {
                                color: lineColor,
                                type: 'dotted'
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: labelColor,
                                fontSize: 12
                            },
                            formatter: '{value}'
                        }
                    },
                    series: seriesData
                };

                return option;
            },
            creatPieOption(data){
                let option = {},
                    totalNum = 0;

                data.forEach((item) => {
                    totalNum += item.value * 1;
                })

                option = {
                    color: pieColor1,
                    title: {
                        text: totalNum,
                        top: '30%',
                        left: 'center',
                        textStyle: {
                            fontSize: 18,
                            fontWeight: 'bold',
                            color: labelColor,
                            padding: [10, 0]
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b} : {c} ({d}%)"
                    },
                    series: [{
                        type: 'pie',
                        hoverAnimation: false,
                        center: ['50%', '40%'],
                        radius: ['50%', '80%'],
                        label: {
                            show: false
                        },
                        data: data
                    }]
                };

                return option;
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import "~@/assets/scss/mixins/_mixins.scss";

    $titleColor: #B5C8FF;
    $borderColor: #17215F;
    $borderDrakColor: #080B26;

    .inner {
        padding: 0 2.08%;
        font-size: .18rem;

        ::v-deep.title-line-main {
            margin-right: 0 !important;
        }

        .chart {
            width: 100%;
            height: calc(100% - 34px);
        }

        .left {
            float: left;
            width: 23.48%;
            height: 100%;

            .part {
                height: 33.333%;
                padding-right: 4.63%
            }
        }

        .center {
            float: left;
            width: 53.37%;
            height: 100%;
            background: url('~@/assets/images/xsjl/mapbg.png') no-repeat center top / 100% 54.6%;

            .map {
                width: 100%;
                height: 52%;
                padding: 7.8% 9.4% 0;
                position: relative;

                .chart {
                    padding: 0;
                }

                .title {
                    width: 18.53%;
                    height: 15.58%;
                    background: url('~@/assets/images/xsjl/map-labelbg.png') no-repeat center center / 100% 100%;
                    @include position(absolute, 83.5%, auto, auto, 3%);
                    font-size: .18rem;
                    font-weight: bold;
                    color: $titleColor;
                    line-height: 1.56;

                    p {
                        white-space: nowrap;
                        transform: translate(-50%, -50%);
                        @include position(absolute, 50%, auto, auto, 50%);
                    }

                }
            }

            .label {
                width: 97.95%;
                height: 14.66%;
                overflow: hidden;

                .notice {
                    width: 69.67%;
                    height: .4rem;
                    overflow: hidden;
                    line-height: .4rem;
                    margin-left: 2.34%;
                    padding-left: .28rem;
                    background: url('~@/assets/images/xsjl/notice.png') no-repeat left center / .28rem 100%;

                    a {
                        color: #fff;
                    }
                }

                @at-root .label-box {
                    height: calc(100% - .51rem);
                    padding: {
                        right: 4.38%;
                        left: 2.34%;
                    }
                    overflow: hidden;

                    .label-box-item {
                        float: left;
                        width: 25%;
                        height: 100%;
                        text-align: center;
                        background: url('~@/assets/images/xsjl/labelbg.png') no-repeat center center / 110% 110%;

                        p {
                            padding-top: .25rem;
                            font-size: .24rem;
                            font-weight: bold;
                            color: $titleColor;
                            line-height: 1.5;
                        }

                        span {
                            font-size: .16rem;
                            color: #4260FF;
                            line-height: 1.625;
                            padding-top: .04rem;
                        }
                    }
                }

            }

            .part-bootom {
                height: 33.333%;
                padding-left: 2.34%;
            }

            .part-item {
                float: left;
                width: 50%;
                height: 100%;
                padding-right: 5.7%;

                &:last-child {
                    padding-right: 8%;
                }
            }
        }

        @at-root .right {
            width: 23.54%;
            height: 96%;
            float: right;
            @include position(absolute, 0, 2.08%);
            background: url('~@/assets/images/xsjl/rightbg.png') no-repeat center center / 100% 100%;

            .part1 {
                height: 36.6%;
                padding-top: .2rem;

                .title {
                    text-align: center;
                    font-size: .18rem;
                    font-weight: bold;
                    color: $titleColor;
                    line-height: .4rem;
                    height: .4rem;
                    background: url('~@/assets/images/xsjl/part1-title.png') no-repeat center center / 100% 130%;
                }

                .chart {
                    height: calc(100% - .6rem);
                    padding: 0 11.1%;
                }
            }

            .part2 {
                height: 31.2%;
                background: url('~@/assets/images/xsjl/linebg-right.png') no-repeat right .4rem / 93.8% .14rem;

                .title {
                    text-align: center;
                    font-size: .18rem;
                    font-weight: bold;
                    color: $titleColor;
                    line-height: .4rem;
                    height: .4rem;
                    padding-bottom: .14rem;
                    background: url('~@/assets/images/xsjl/part2-title.png') no-repeat right center / 99% 130%;
                    position: relative;

                    .icon {
                        display: inline-block;
                        content: '';
                        width: .4rem;
                        height: .4rem;
                        background: url('~@/assets/images/xsjl/icon-video.png') no-repeat center center / 130% 130%;
                        @include position(absolute, 0, 17%, auto, auto);
                    }

                }

                .chart-box {
                    margin-top: .14rem;
                    padding: 14% 4.4%;
                    height: calc(100% - .54rem);
                    position: relative;
                    background: url('~@/assets/images/xsjl/piebg-top.png') no-repeat center 6.4% / 59.5% 10.76%;

                    &:after {
                        display: inline-block;
                        content: '';
                        width: 100%;
                        height: 10.76%;
                        background: url('~@/assets/images/xsjl/pie-bottom.png') no-repeat center bottom / 59.5% 100%;
                        @include position(absolute, auto, 0, 6.4%, 0);
                    }

                    .chart-pie {
                        float: left;
                        width: 33.33%;
                        padding-right: .22%;
                        height: 100%;
                        position: relative;
                        &:last-child {
                            padding-right: 0;
                        }
                    }

                    .chart {
                        height: 100%;
                    }

                    .chart-title {
                        text-align: center;
                        color: $titleColor;
                        font-size: .16rem;
                        @include position(absolute, auto, 0, 20%, 0);

                    }
                }

            }

            .part3 {
                height: 32.2%;
                padding-top: .14rem;
                background: url('~@/assets/images/xsjl/linebg-left.png') no-repeat left top / 93.8% .14rem;

                .title {
                    text-align: left;
                    font-size: .18rem;
                    font-weight: bold;
                    color: $titleColor;
                    line-height: .4rem;
                    height: .4rem;
                    padding-left: 2.9%;
                    position: relative;
                    background: url('~@/assets/images/xsjl/part3-title.png') no-repeat center 55% / 108% 130%;
                }

                .select-box {
                    width: 26.54%;
                    height: .3rem;
                    border: 1px solid #233388;
                    @include position(absolute, auto, 11.1%, .05rem);

                    select {
                        display: block;
                        width: 100%;
                        color: $titleColor;
                        padding: 0 .1rem;
                        height: .3rem;
                        font-size: .16rem;
                        line-height: .3rem;
                        background: transparent;
                        border: none;
                    }

                }

                .chart {
                    height: calc(100% - .54rem);
                    padding: 0 6.4%;
                }
            }

        }

    }

</style>